import type { DuplicatePaperRef } from "./types";

/**
 * G-121 S4 (OD-144): the server refuses a file already in the app with a 409
 * whose body carries `code: "DUPLICATE_PAPER"` and the paper that is there.
 * This reads that body off the thrown request error, so the upload page can
 * link to it instead of showing a bare conflict.
 */
export function duplicatePaperFromError(err: unknown): DuplicatePaperRef | null {
  if (!err || typeof err !== "object") return null;
  const body = (err as { body?: unknown }).body;
  if (!body || typeof body !== "object") return null;
  const b = body as { code?: unknown; details?: { existing?: unknown } };
  const existing = b.details?.existing;
  if (b.code !== "DUPLICATE_PAPER" || !existing || typeof existing !== "object") return null;
  const ref = existing as { canOpen?: unknown; id?: unknown; locationName?: unknown };
  if (ref.canOpen === false) return { canOpen: false };
  return ref.canOpen === true && typeof ref.id === "string" && typeof ref.locationName === "string"
    ? (existing as DuplicatePaperRef)
    : null;
}
